import React from 'react';
import { Tooltip } from 'antd';
import { InfoCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons';

interface InfoTooltipProps {
  /**
   * Texto de ayuda a mostrar en el tooltip
   */
  text: string;
  /**
   * Tipo de icono a mostrar
   * @default 'info'
   */
  icon?: 'info' | 'question';
  /**
   * Posición del tooltip
   * @default 'top'
   */
  placement?: 'top' | 'topLeft' | 'topRight' | 'bottom' | 'bottomLeft' | 'bottomRight' | 'left' | 'right';
  /**
   * Color del icono
   * @default '#8c8c8c'
   */
  iconColor?: string;
  /**
   * Tamaño del icono
   * @default 21
   */
  iconSize?: number;
}

/**
 * Componente InfoTooltip
 * Muestra un icono discreto de ayuda/información que al hacer hover muestra un tooltip
 *
 * @example
 * <InfoTooltip text="Esto es una ayuda" />
 * <InfoTooltip text="Pregunta frecuente" icon="question" placement="right" />
 */
const InfoTooltip: React.FC<InfoTooltipProps> = ({
  text,
  icon = 'info',
  placement = 'top',
  iconColor = '#8c8c8c',
  iconSize = 21,
}) => {
  const IconComponent = icon === 'question' ? QuestionCircleOutlined : InfoCircleOutlined;

  return (
    <Tooltip
      title={text}
      placement={placement}
      trigger="hover"
      mouseEnterDelay={0.2}
      mouseLeaveDelay={0}
      overlayStyle={{
        maxWidth: '300px',
      }}
      overlayInnerStyle={{
        backgroundColor: '#fffbea',
        color: '#262626',
        border: '1px solid #ffd666',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
      }}
      color="#fffbea"
    >
      <IconComponent
        style={{
          fontSize: `${iconSize}px`,
          color: iconColor,
          cursor: 'help',
          marginLeft: '6px',
          verticalAlign: 'middle',
          opacity: 0.7,
          transition: 'opacity 0.2s',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.opacity = '1';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.opacity = '0.7';
        }}
      />
    </Tooltip>
  );
};

export default InfoTooltip;
